import { useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import type { EventCalendarEntry } from "../eventCalendarConstants";
import { eventChartDataQueryKeys } from "./queryKeys";

export function useFetchEventChartData(enabled: boolean) {
  const apiClient = useApi();

  return useQuery({
    queryKey: eventChartDataQueryKeys.data(),
    meta: {
      errorMessage: "Failed to fetch event chart data"
    },
    queryFn: async (): Promise<EventCalendarEntry[]> => {
      const response = await apiClient.GET("/v2/forecast/charts/events");
      const result = response.data?.result?.events;
      if (!result) {
        throw new Error("Missing result in event chart data response");
      }
      return result;
    },
    staleTime: Infinity,
    enabled
  });
}
